import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableQazanj from "./ScroollTableQazanj";
import NavbarOfQazanj from "./NavbarOfQazanj";
import FooterOfQazanj from "./FooterOfQazanj";
import Time from "react-time-format";
import { ProductConsumer } from "../../../Context/AddProWakel";
const AllQazanj = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { Q_from, Q_to } = value;
          return (
            <>
              <Navbar />
              <div className="row" style={{ backgroundColor: "#2C3539" }}>
                <div
                  className="col-lg-10  col-12"
                  style={{ marginTop: "60px" }}
                >
                  <div className="row">
                    <div className="col-3">
                      <div className="row">
                        {/* <div className="col-3"></div> */}
                        <div className="col-lg-6 col-10   tc form-inline">
                          <p className="font-weight-bold bg-white text-black f4">
                            <Time format="YYYY-MM-DD" />
                          </p>
                          <span style={{ backgroundColor: "#2C3539" }}>:</span>
                          <p className="font-weight-bold bg-white text-black f4">
                            {Q_to}
                          </p>
                        </div>
                        <div className="col-lg-6 col-10 form-inline">
                          <label
                            className=" font-weight-bold f4 text-warning"
                            style={{ fontWeight: "bolder" }}
                          >
                            :بۆ بەرواری{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="row">
                        <div className="col-lg-6 col-10  tc form-inline">
                          <p className="font-weight-bold bg-white text-black   f4">
                            <Time format="YYYY-MM-DD" />
                          </p>
                          <span style={{ backgroundColor: "#2C3539" }}>:</span>
                          <p className="font-weight-bold bg-white  text-black  f4">
                            {Q_from}
                          </p>
                        </div>
                        <div className="col-lg-6 col-10  form-inline">
                          <label className=" font-weight-bold f4 text-warning">
                            : لە بەرواری{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-6" style={{ paddingTop: "7px" }}>
                      <div className="row">
                        <div className="col-1">
                          <h4 className="text-warning font-weight-bold f4 bg-white tc"></h4>
                        </div>
                        <div className="col-10">
                          <h4 className="font-weight-bold f2 tc text-warning">
                            ڕاپۆرتی قازانج
                          </h4>
                        </div>
                        <div className="col-1">
                          <h4 className="text-warning font-weight-bold f4 bg-white tc">
                            {" "}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row ">
                <div className="col-lg-10 col-8">
                  <ScroollTableQazanj />
                </div>
                <div className="col-lg-2 col-4">
                  <NavbarOfQazanj />
                </div>
              </div>
              <div className="row" style={{ backgroundColor: "#2C3539" }}>
                <div className="col-12 col-12">
                  <FooterOfQazanj />
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default AllQazanj;
